import React, {useRef, useEffect} from "react";
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {Card, Form} from "reactstrap";
import InputCreator from "../../../components/Forms/components/InputCreator";
import SelectCreator from "../../../components/Forms/components/SelectCreator";
import Button from "../../../components/Button";
import {
  storeReportSelectedControllerList,
  requestReportSites,
  requestReportLocations,
  requestReportControllers,
  storeCreateReportData,
  storeReportControllers,
} from "../../../redux/Actions/reports.actions";
import {
  getSelectedControllerList,
  getReportSites,
  getReportLocations,
  getReportControllers,
  getCreateReportData,
} from "../../../redux/Selectors/reports.selectors";

const AddControllerForm = () => {
  const dispatch = useDispatch();
  const {reportId} = useParams();
  const selectedControllerList = useSelector(getSelectedControllerList);
  const createReportData = useSelector(getCreateReportData);
  const {name = "", status, site, location, controller} = createReportData;
  const siteOptions = useSelector(getReportSites);
  const locationOptions = useSelector(getReportLocations);
  const controllerOptions = useSelector(getReportControllers);

  const locationRef = useRef();
  const controllerRef = useRef();

  useEffect(() => {
    dispatch(requestReportSites());
    if (site) {
      dispatch(requestReportLocations(site));
    }
    if (location) {
      dispatch(requestReportControllers(location));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSiteChange = (e) => {
    dispatch(storeCreateReportData({name, site: e.target.value}));
    dispatch(requestReportLocations(e.target.value));
    dispatch(storeReportControllers([]));
  };

  const handleLocationChange = (e) => {
    dispatch(storeCreateReportData({name, site, location: e.target.value}));
    dispatch(requestReportControllers(e.target.value));
  };

  const handleControllerChange = (e) => {
    if (e.target.value) {
      dispatch(
        storeCreateReportData({
          ...createReportData,
          controller: {label: e.target.label, value: e.target.value},
        })
      );
    }
  };

  const handleNameChange = (e) => {
    dispatch(
      storeCreateReportData({
        ...createReportData,
        name: e.target.value,
      })
    );
  };

  const addController = () => {
    if (controller?.value) {
      const index = selectedControllerList.findIndex(
        (eachController) => eachController.value === controller.value
      );
      if (index === -1) {
        dispatch(
          storeReportSelectedControllerList([
            ...selectedControllerList,
            {
              name: controller.label,
              mac: controller.value,
              records: [],
              comments: [],
            },
          ])
        );
      } else {
        toast.error("This appliance is already added");
      }
    } else {
      toast.error("Please check required fields");
    }
  };

  return (
    <Card style={{padding: "1rem 0px", boxShadow: "0px 3px 6px #00000029"}}>
      <div
        className="roboto-bold"
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          borderBottom: "1px solid #20C1FF",
          margin: "0px 1rem 1rem 1rem",
          color: "#303030",
          paddingBottom: "5px",
        }}
      >
        {`${
          reportId
            ? `${status === "under-review" || status === "submitted" ? "Review" : "Edit"}`
            : "Add"
        } Report`}
      </div>
      <Form>
        <InputCreator
          large
          inSingleRow
          label={"Name"}
          isRequired
          onChange={handleNameChange}
          value={name}
          name={"name"}
          placeholder="Enter Name"
          style={{
            border: "1px solid #d6d6d6",
            maxHeight: "38px",
            boxShadow: "none",
          }}
          disabled={status === "under-review" || status === "submitted"}
          data-cy="reportName"
        />
        <SelectCreator
          inSingleRow
          label={"Site"}
          isRequired
          closeMenuOnSelect={true}
          name={"site"}
          options={siteOptions}
          onChange={handleSiteChange}
          value={site}
          colSize={12}
          placeholder={"Select Site"}
          classNamePrefix={"selectSite"}
          id={"selectSite"}
          isDisabled={
            selectedControllerList?.length > 0 ||
            status === "under-review" ||
            status === "submitted"
          }
        />
        <SelectCreator
          inSingleRow
          label={"Location"}
          isRequired
          closeMenuOnSelect={true}
          name={"location"}
          options={locationOptions}
          onChange={handleLocationChange}
          value={location}
          ref={locationRef}
          colSize={12}
          placeholder={"Select Location"}
          classNamePrefix={"selectLocation"}
          id={"selectLocation"}
          isDisabled={
            selectedControllerList?.length > 0 ||
            status === "under-review" ||
            status === "submitted"
          }
        />
        <SelectCreator
          inSingleRow
          label={"Appliance"}
          isRequired
          closeMenuOnSelect={true}
          name={"controller"}
          options={controllerOptions}
          onChange={handleControllerChange}
          value={controller?.value}
          ref={controllerRef}
          colSize={12}
          placeholder={"Select Appliance"}
          classNamePrefix={"selectController"}
          id={"selectController"}
          isDisabled={
            selectedControllerList?.length > 0 ||
            status === "under-review" ||
            status === "submitted"
          }
          help_text="Only those appliances will be available for selection for which template is already created"
        />
        {selectedControllerList?.length === 0 && (
          <div className="d-flex justify-content-end" style={{marginRight: "1rem"}}>
            <Button withRadius onClick={addController} data-cy="addAppliance">
              ADD APPLIANCE
            </Button>
          </div>
        )}
      </Form>
    </Card>
  );
};

export default AddControllerForm;
